/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Timing_Sync_Mode_LabelInputs */



/**
* | output |
* | --- |
* | "Timing Mode" |
*
* @param {Timing_Sync_Mode_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const timing_sync_mode_label = /** @type {((inputs?: Timing_Sync_Mode_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Timing_Sync_Mode_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Mode de minutage")
	if (locale === "de") return /** @type {LocalizedString} */ ("Timing-Modus")
	if (locale === "it") return /** @type {LocalizedString} */ ("Modalità di temporizzazione")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Режим синхронизации")
	if (locale === "es") return /** @type {LocalizedString} */ ("Modo de sincronización")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("定时模式")
	if (locale === "ja") return /** @type {LocalizedString} */ ("タイミングモード")
	if (locale === "hi") return /** @type {LocalizedString} */ ("टाइमिंग मोड")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Modo de temporização")
	return /** @type {LocalizedString} */ ("Timing Mode")
});